import React from 'react';
import axios from "axios";
import useSWR from "swr";
import PartnerCard from "../partners/partnerCard";
import {Grid} from "@material-ui/core";
import colorPalette from "../../../../styles/theme/colorPalette";
import {Container, Typography} from "@mui/material";
import {css} from "@emotion/react";

const fetcherWithParams = (url, params) => axios.get(url, {params: params}).then(res => res.data);

const Partners = () => {
  
  const addressesUrl = `${process.env.NEXT_PUBLIC_API_BASE_URL}/api/v1/partners`
  const {data: partners} = useSWR([addressesUrl, 1], (url, params) => fetcherWithParams(url, {
    page: 1,
    limit: 3
  }));
  
  return (
      <div css={wrapper} id={'partners'}>
        <Container>
          <div css={{marginBottom: '32px'}}>
            <Typography variant={'h1'} css={mainTitle}>
              <span>ミールタイムのここがいい！</span>
            </Typography>
            <div css={subtitle}>
              医療機関栄養士がお答えします！
            </div>
          </div>
          {
            partners &&
            <>
              <Grid container spacing={2}>
                {
                  partners.data.map((partner, i) => (
                      <Grid item key={`${partner.id}_${i}`} xs={12}>
                        <PartnerCard data={partner} isCommentCut={false} />
                      </Grid>
                  ))
                }
              </Grid>
            </>
          }
        </Container>
      </div>
  );
};

export default Partners;

const mainTitle = css`
  font-weight: bold;
  color: ${colorPalette.primary};
  padding: 1rem;
`

const subtitle = css`
  background-color: ${colorPalette.primary};
  padding: 0.5rem 1rem;
  max-width: 300px;
  text-align: center;
  margin: 0 auto;
  border-radius: 8px;
  color: ${colorPalette.white};
  font-weight: bold;
`

const wrapper = css`
  margin-bottom: 24px;
`